import React from 'react'
import moment from 'moment'

import {
    toWeekInt,
    toWeekDaysArrayFull
} from '../../../../helpers/moment'

const WeekView = ({ 
    activeDate,
    activeWeek,
    startDay,
    backToToday,
    changeActiveDate,
    changeToNextWeek,
    changeToPrevWeek 
}) => {
    let activeClass = "  bg-brand text-white shadow-sm"

    return (
        <div className="week-calendar">
            <div className="d-flex align-items-center justify-content-between">
                <div>
                    <div className="py-2">Week {toWeekInt(moment(activeWeek.startDate), startDay)}</div>
                    <h6 style={{fontSize: '1.2rem'}}>{moment(activeWeek.startDate).format('DD')} - {moment(activeWeek.endDate).format('DD MMMM YYYY')}</h6>
                </div>
                <div className="text-right" style={{minWidth: '95px'}}>
                    <button 
                        className="btn btn-light text-dark border bg-white p-1 mr-2"
                        onClick={() => changeToPrevWeek(activeWeek.startDate, activeWeek.endDate)}
                        style={{
                            borderRadius: '50%',
                            height: '25px',
                            width: '25px',
                            lineHeight: '1.1rem'
                        }}><i className="fas fa-chevron-left"></i></button>
                        <button
                            className="btn btn-light text-dark border bg-white p-1"
                            onClick={() => backToToday()}
                            style={{
                                borderRadius: '50%',
                                height: '25px',
                                width: '25px',
                                lineHeight: '1.1rem'
                            }}>
                            <i className="far fa-circle"></i>
                        </button>
                    <button 
                        className="btn btn-light text-dark border bg-white p-1 ml-2"
                        onClick={() => changeToNextWeek(activeWeek.startDate, activeWeek.endDate)}
                        style={{
                            borderRadius: '50%',
                            height: '25px',
                            width: '25px',
                            lineHeight: '1.1rem'
                        }}><i className="fas fa-chevron-right"></i></button>
                </div>
            </div>
            <div className="rounded" style={{backgroundColor: '#fafafa'}}>
                <div className="d-flex justify-items-center nowrap">
                    { 
                        activeWeek && toWeekDaysArrayFull(moment(activeWeek.startDate), startDay).map((date, index) => (
                            <div 
                                key={index} 
                                className="flex-grow-1 pb-3 text-center"
                                onClick={() => changeActiveDate(moment(date).format('YYYY-MM-DD'))}>
                                <div className="py-1 pb-2 text-muted">{moment(date).format('dd')}</div>
                                <div 
                                    className={"pt-1 m-auto" + (moment(date).format('YYYY-MM-DD') === moment(activeDate).format('YYYY-MM-DD') ? activeClass : "")}
                                    style={
                                        {
                                            borderRadius: '50%', 
                                            height: '30px', 
                                            width: '30px',
                                            textAlign: 'center',
                                            lineHeight: '1.5rem',
                                        }
                                    }>{moment(date).format('DD')}</div>
                            </div>
                        )) 
                    }
                </div>
            </div>
        </div>
    )
}

export default WeekView
